@if (text) {
  <div class="field-issue-message severity-failure" role="alert">
    <svg lucideCircleAlert aria-hidden="true"></svg>
    <span>{{ text }}</span>
  </div>
}
